"use client"

import { useState, useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { AuthContext } from "../../context/AuthContext"
import api from "../../services/api"
import DashboardLayout from "../../components/Layout/DashboardLayout"
import MiniFooter from "../../components/Layout/miniFooter"
import Breadcrumbs from "../../components/Layout/Breadcrumbs"
import { Button } from "react-bootstrap"
import {
  FaGlobe,
  FaPlus,
  FaCheck,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
  FaTrash,
  FaStar,
  FaCheckCircle,
  FaClock
} from "react-icons/fa"

export default function CustomDomainsPage() {
  const { user } = useContext(AuthContext)
  const navigate = useNavigate()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [domainsData, setDomainsData] = useState([])
  const [expandedIds, setExpandedIds] = useState([])
  const [deleteConfirmId, setDeleteConfirmId] = useState(null)

  // Fetch domains
  const fetchDomains = async () => {
    try {
      const res = await api.get("/domains")
      setDomainsData(res.data?.data.domains || [])
    } catch (err) {
      console.error(err)
      setError("Failed to fetch domains.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDomains()
    const interval = setInterval(fetchDomains, 60000)
    return () => clearInterval(interval)
  }, [])

  const toggleExpand = (id) =>
    setExpandedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])

 const verifyDomain = async (domainId) => {
  try {
    const res = await api.post(`/domains/${domainId}/verify`);
    if (res.data.success) {
      alert(res.data.message); // Domain verified
    }
    fetchDomains();
  } catch (err) {
    const message = err.response?.data?.message || "Failed to verify domain.";
    alert(message);
  }
};

  const setPrimaryDomain = async (domainId) => { try { await api.post(`/domains/${domainId}/primary`); fetchDomains() } catch { alert("Failed to set domain as primary.") } }
  const deleteDomain = async (domainId) => { if (!user?.id) return alert("User not found."); try { await api.delete(`/domains/${domainId}`); fetchDomains() } catch { alert("Failed to delete domain.") } finally { setDeleteConfirmId(null) } }

  const breadcrumbItems = [
    { name: "Dashboard", path: "/user-dashboard" },
    { name: "Branded Domains" }
  ]

  if (loading) return (
    <DashboardLayout>
      <div className="container py-4 text-center">Loading domains...</div>
    </DashboardLayout>
  )

  if (error) return (
    <DashboardLayout>
      <div className="mx-auto mt-5 p-4 text-center error-box">
        <FaTimes size={36} />
        <p>{error}</p>
      </div>
    </DashboardLayout>
  )

  return (
    <DashboardLayout>
      <div className="domains-page py-4">
        <Breadcrumbs items={breadcrumbItems} />
        {/* Add this inside your DashboardLayout, just below the breadcrumb and before the domain list */}
<div className="dns-guide mb-4 p-4 rounded" style={{ background: "#e0f2fe", border: "1px solid #bae6fd" }}>
  <h5 style={{ marginBottom: "12px", fontWeight: 600 }}>DNS Guide</h5>
  <ul style={{ margin: 0, paddingLeft: "20px", color: "#1e293b" }}>
    <li>
      <strong>TXT Record:</strong> Used to verify ownership of your domain. Add the TXT record provided by our system to your DNS settings.
    </li>
    <li>
      <strong>CNAME Record:</strong> Connects your domain to our platform. Add the CNAME record exactly as shown in the DNS section.
    </li>
    <li>
      After adding the records, click <strong>Verify</strong> to confirm the domain.
    </li>
    <li>
      DNS changes may take a few minutes to propagate.
    </li>
  </ul>
</div>

        <div className="page-header mb-4">
          <div>
            <h2 className="page-title">Custom Domains</h2>
            <p className="page-subtitle">Manage your branded domains and DNS records</p>
          </div>
          <Button className="btn-add-domain" onClick={() => navigate("/dashboard/custom-domains/add")}>
            <FaPlus /> Add Domain
          </Button>
        </div>

        {domainsData.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon"><FaGlobe size={28} /></div>
            <h4>No Domains Found</h4>
            <p>Get started by adding your first custom domain</p>
            <Button className="btn-add-domain" onClick={() => navigate("/dashboard/custom-domains/add")}>
              <FaPlus /> Add Your First Domain
            </Button>
          </div>
        ) : (
          <div className="domains-list">
            {domainsData.map(domain => {
              const isExpanded = expandedIds.includes(domain._id)
              const showDeleteConfirm = deleteConfirmId === domain._id
const statusConfig = {
  active: {
    label: "Active",
    color: "#16a34a",
    icon: <FaCheck />
  },
  ssl_pending: {
    label: "SSL Pending",
    color: "#2563eb",
    icon: <FaClock />
  },
  pending_dns: {
    label: "Pending DNS",
    color: "#b45309",
    icon: <FaClock />
  },
  failed: {
    label: "Failed",
    color: "#dc2626",
    icon: <FaTimes />
  }
}
const currentStatus = statusConfig[domain.status] || {
  label: domain.status,
  color: "#64748b",
  icon: <FaClock />
}


              return (
                <div className="domain-card mb-4" key={domain._id}>
                  <div className="domain-header d-flex justify-content-between align-items-center" onClick={() => toggleExpand(domain._id)}>
                    <div className="domain-title">
                      {domain.domain} {domain.isPrimary && <span className="primary-label">(Primary)</span>}
                    </div>
                    <div className="domain-status d-flex align-items-center gap-2">
                      <span className="status-badge" style={{ backgroundColor: currentStatus.color + "22", color: currentStatus.color }}>
                        {currentStatus.icon} {currentStatus.label}
                      </span>
                      {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="domain-body mt-3">
<div className="dns-records mb-3">
  {domain.dns?.txt?.host && (
    <div className="dns-record">
      <span className="dns-type">TXT</span>
      <span className="dns-value">{domain.dns.txt.host}</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText(domain.dns.txt.host)}
      >
        Copy Host
      </button>
      <span className="dns-value">{domain.dns.txt.value}</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText(domain.dns.txt.value)}
      >
        Copy Value
      </button>
    </div>
  )}

  {domain.dns?.cname ? (
    <div className="dns-record">
      <span className="dns-type">CNAME</span>
      <span className="dns-value">{domain.dns.cname.host}</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText(domain.dns.cname.host)}
      >
        Copy Host
      </button>
      <span className="dns-value">{domain.dns.cname.value}</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText(domain.dns.cname.value)}
      >
        Copy Value
      </button>
    </div>
  ) : (
    <div className="dns-record">
      <span className="dns-type">ALIAS / ANAME</span>
      <span className="dns-value">{domain.domain}</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText(domain.domain)}
      >
        Copy Host
      </button>
      <span className="dns-value">app.u2lr.com</span>
      <button
        className="btn-copy"
        onClick={() => navigator.clipboard.writeText("app.u2lr.com")}
      >
        Copy Value
      </button>
    </div>
  )}
</div>

<style>{`
.dns-record {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.dns-type {
  font-weight: 600;
  width: 100px;
}

.dns-value {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: monospace;
}

.btn-copy {
  padding: 2px 8px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: 0.2s ease;
}

.btn-copy:hover {
  background: #2563eb;
}

@media (max-width: 768px) {
  .dns-record {
    flex-direction: column;
    align-items: flex-start;
  }
}
`}</style>



                      <div className="domain-actions">
                        {domain.status !== "active" && (
                          <Button
                            size="sm"
                            variant="success"
                            onClick={() => verifyDomain(domain._id)}
                          >
                            <FaCheckCircle />
                            {domain.dns?.cname ? "Verify" : "Check ALIAS/ANAME"}
                          </Button>
                        )}
                        {!domain.isPrimary && <Button size="sm" variant="warning" onClick={() => setPrimaryDomain(domain._id)}><FaStar /> Set Primary</Button>}
                        {!showDeleteConfirm && <Button size="sm" variant="danger" onClick={() => setDeleteConfirmId(domain._id)}><FaTrash /> Delete</Button>}
                        {showDeleteConfirm && (
                          <div className="d-flex gap-1 align-items-center">
                            <span>Confirm?</span>
                            <Button size="sm" variant="danger" onClick={() => deleteDomain(domain._id)}>Yes</Button>
                            <Button size="sm" variant="secondary" onClick={() => setDeleteConfirmId(null)}>No</Button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>

      <MiniFooter />

      <style>{`
.domains-page {
  background: #f8fafc;
  min-height: 100vh;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

@media (min-width: 1440px) {
  .domains-page {
    max-width: 1400px;
  }
}

        .page-title { color: #1e293b; font-weight: 700; margin-bottom: 4px; }
        .page-subtitle { color: #64748b; margin: 0; }
        .btn-add-domain { background: #3b82f6; border: none; color: white; padding: 10px 20px; border-radius: 8px; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; transition: 0.2s ease; }
        .btn-add-domain:hover { background: #2563eb; }
        .empty-state { background: white; border: 2px dashed #e2e8f0; border-radius: 12px; padding: 48px; text-align: center; margin-top: 20px; }
        .empty-icon { width: 64px; height: 64px; background: #f1f5f9; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; color: #64748b; }
        .domain-card { background: white; border-radius: 12px; padding: 24px;

@media (max-width: 768px) {
  .domain-card {
    padding: 16px;
  }
}

        border: 1px solid #e2e8f0; box-shadow: 0 4px 12px rgba(0,0,0,0.05); transition: all 0.3s ease; cursor: pointer; width: 100%; }
        .domain-card:hover { border-color: #3b82f6; box-shadow: 0 8px 24px rgba(59,130,246,0.1); }
        .domain-header { font-weight: 600; font-size: 18px; }
        .primary-label { background: #3b82f6; color: white; padding: 2px 6px; border-radius: 4px; font-size: 12px; margin-left: 6px; }
        .status-badge { display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; border-radius: 20px; font-weight: 600; font-size: 13px; }
        .dns-records code { background: #f1f5f9; padding: 2px 6px; border-radius: 4px; font-size: 14px; }
        .domain-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .domain-actions {
    flex-direction: column;
  }

  .domain-actions button {
    width: 100%;
  }
}

        .dns-guide h5 {
  color: #0c4a6e;
}
.dns-guide ul li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.dns-records code {
  background: #f1f5f9;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 13px;
  display: inline-block;
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .btn-add-domain {
    width: 100%;
    justify-content: center;
  }
}

      `}</style>
    </DashboardLayout>
  )
}
